/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_V1_Interest_Notable_Investor_TrackersInputs */

const en_onboarding_v1_interest_notable_investor_trackers = /** @type {(inputs: Onboarding_V1_Interest_Notable_Investor_TrackersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Famous Investor or Politician Trackers`)
};

const de_onboarding_v1_interest_notable_investor_trackers = /** @type {(inputs: Onboarding_V1_Interest_Notable_Investor_TrackersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tracker bekannter Investoren oder Politiker`)
};

const pt_br2_onboarding_v1_interest_notable_investor_trackers = /** @type {(inputs: Onboarding_V1_Interest_Notable_Investor_TrackersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rastreadores de investidores famosos ou políticos`)
};

const tr_onboarding_v1_interest_notable_investor_trackers = /** @type {(inputs: Onboarding_V1_Interest_Notable_Investor_TrackersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ünlü yatırımcı veya siyasetçi takipçileri`)
};

const zh_cn2_onboarding_v1_interest_notable_investor_trackers = /** @type {(inputs: Onboarding_V1_Interest_Notable_Investor_TrackersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`知名投资者或政治人物跟踪策略`)
};

const zh_hk2_onboarding_v1_interest_notable_investor_trackers = /** @type {(inputs: Onboarding_V1_Interest_Notable_Investor_TrackersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`知名投資者或政治人物追蹤策略`)
};

const ko_kr2_onboarding_v1_interest_notable_investor_trackers = /** @type {(inputs: Onboarding_V1_Interest_Notable_Investor_TrackersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`유명 투자자 또는 정치인 추종 전략`)
};

const ru_ru2_onboarding_v1_interest_notable_investor_trackers = /** @type {(inputs: Onboarding_V1_Interest_Notable_Investor_TrackersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Стратегии известных инвесторов или политиков`)
};

const es_419_onboarding_v1_interest_notable_investor_trackers = /** @type {(inputs: Onboarding_V1_Interest_Notable_Investor_TrackersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rastreadores de inversionistas famosos o políticos`)
};

/**
* | output |
* | --- |
* | "Famous Investor or Politician Trackers" |
*
* @param {Onboarding_V1_Interest_Notable_Investor_TrackersInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const onboarding_v1_interest_notable_investor_trackers = /** @type {((inputs?: Onboarding_V1_Interest_Notable_Investor_TrackersInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_V1_Interest_Notable_Investor_TrackersInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onboarding_v1_interest_notable_investor_trackers(inputs)
	if (locale === "de") return de_onboarding_v1_interest_notable_investor_trackers(inputs)
	if (locale === "pt-BR") return pt_br2_onboarding_v1_interest_notable_investor_trackers(inputs)
	if (locale === "tr") return tr_onboarding_v1_interest_notable_investor_trackers(inputs)
	if (locale === "zh-CN") return zh_cn2_onboarding_v1_interest_notable_investor_trackers(inputs)
	if (locale === "zh-HK") return zh_hk2_onboarding_v1_interest_notable_investor_trackers(inputs)
	if (locale === "ko-KR") return ko_kr2_onboarding_v1_interest_notable_investor_trackers(inputs)
	if (locale === "ru-RU") return ru_ru2_onboarding_v1_interest_notable_investor_trackers(inputs)
	return es_419_onboarding_v1_interest_notable_investor_trackers(inputs)
});